/* MASI 3-month plan card (preview theme only). Runs after masi-r28-pdp.js (both deferred). */
(() => {
  "use strict";
  const card = document.getElementById("three-month-card"),
    dataNode = document.querySelector("[data-masi-3m-data]"),
    api = window.MasiCart,
    form = document.getElementById("purchase");
  if (!card || !dataNode || !api || !form) return;
  const d = JSON.parse(dataNode.textContent),
    $ = (id) => document.getElementById(id),
    radio = $("three-month"),
    money = (c) => api.money(c),
    t = api.config.strings;
  let on = Boolean(d.plan) && !$("one-time")?.checked && !["subscribe", "one-time"].includes(new URLSearchParams(location.search).get("plan"));
  const useOneAdult = () => { if ($("adult-two")?.checked) $("adult-one")?.click(); };
  if (form.dataset.ready) useOneAdult();
  else document.addEventListener("DOMContentLoaded", useOneAdult, { once: true });
  const adults = () => Number(document.querySelector('input[name="adults"]:checked')?.value || 1);
  function paint() {
    const a = adults(), jars = 3 * a, unit = a > 1 ? d.unit2 : d.unit, pct = (d.list > 0 && Math.round((1 - (a > 1 ? d.unit2 : d.unit) / d.list) * 100)) || (a > 1 ? 20 : 15), total = unit * jars, list = d.list * jars;
    const T = d.t, fill = (s, m) => Object.entries(m).reduce((x, [k, v]) => x.split(`[${k}]`).join(v), s);
    $("m3-save").textContent = fill(T.save, { n: pct });
    $("m3-pct-line").textContent = fill(T.pct, { n: pct, unit: T.unit });
    card.querySelectorAll("[data-m3-adults]").forEach((b) => b.setAttribute("aria-pressed", String(+b.dataset.m3Adults === a)));
    $("m3-order").textContent = money(total);
    $("m3-list").textContent = money(list);
    $("m3-day").textContent = money(a > 1 ? total / 90 / a : total / 90);
    $("m3-day").nextElementSibling.textContent = a > 1 ? d.t.aday : d.t.day;
    $("m3-quantity").textContent = fill(T.qty, { n: jars, units: T.units, price: money(unit), unit: T.unit });
    if (!on) return;
    radio.checked = true;
    ["subscribe", "one-time"].forEach((id) => { const r = $(id); if (r) r.checked = false; });
    ["subscribe-card", "one-time-card"].forEach((id) => $(id)?.classList.remove("selected"));
    card.classList.add("selected");
    $("subscribe-body") && ($("subscribe-body").hidden = true);
    $("m3-body").hidden = false;
    $("renewal-copy").textContent = fill(T.renew, { amount: money(total) });
    $("subscription-terms-link") && ($("subscription-terms-link").hidden = false);
    form.classList.add("is-3m");
    const sticky = $("sticky-plan"), sel = $("sticky-selection");
    const txt = `${T.title} · ${jars} ${T.units}`;
    sticky && (sticky.textContent = txt); sel && (sel.textContent = txt);
    $("sticky-total") && ($("sticky-total").textContent = money(total));
    $("sticky-list") && (($("sticky-list").textContent = money(list)), ($("sticky-list").hidden = false));
    $("sticky-day") && ($("sticky-day").textContent = a > 1 ? money(total / 90 / a) + T.aday : money(total / 90) + T.day);
    $("sticky-discount") && (($("sticky-discount").textContent = fill(T.save, { n: pct })), ($("sticky-discount").hidden = false));
    $("sticky-purchase")?.classList.remove("is-one-time");
    fixLabel();
  }
  // v24: base PDP script labels the CTA from its own state (may still be one-time); force the subscription label while 90-day is on.
  function fixLabel() {
    if (!on || !d.t.start) return;
    if ([form.querySelector(".cta"), $("sticky-cta")].some((c) => c?.classList.contains("is-adding"))) return;
    ["cta-label", "sticky-cta-label"].forEach((id) => { const n = $(id); if (n && n.textContent !== d.t.start) n.textContent = d.t.start; });
  }
  function off() {
    on = false; radio.checked = false; card.classList.remove("selected");
    $("m3-body").hidden = true; form.classList.remove("is-3m");
  }
  radio.addEventListener("change", () => { on = true; paint(); });
  card.addEventListener("click", (e) => {
    if (e.target.closest("a,button,input,label,select,textarea,details")) return;
    if (!radio.checked) { radio.checked = true; on = true; paint(); }
  });
  document.querySelectorAll('input[name="selling_plan"]').forEach((r) =>
    r.addEventListener("change", () => { off(); paint(); }));
  document.querySelectorAll('input[name="adults"]').forEach((r) =>
    r.addEventListener("change", () => setTimeout(paint, 0)));
  card.querySelectorAll("[data-m3-adults]").forEach((b) => b.addEventListener("click", () => {
    const r = $(b.dataset.m3Adults === "2" ? "adult-two" : "adult-one");
    if (r && !r.checked) r.click();
    setTimeout(paint, 0);
  }));
  const subLabel = $("subscribe-card")?.querySelector(".plan-select");
  if (subLabel) {
    const g = document.createElement("div");
    g.className = "m30-adults"; g.setAttribute("role", "group");
    g.innerHTML = '<button type="button" data-m30-adults="1"></button><button type="button" data-m30-adults="2"></button>';
    g.children[0].textContent = d.t.a1; g.children[1].textContent = d.t.m2;
    subLabel.after(g);
    const sync = () => g.querySelectorAll("button").forEach((b) => b.setAttribute("aria-pressed", String(+b.dataset.m30Adults === adults())));
    g.querySelectorAll("button").forEach((b) => b.addEventListener("click", () => {
      const r = $(b.dataset.m30Adults === "2" ? "adult-two" : "adult-one");
      if (r && !r.checked) r.click();
      sync();
    }));
    document.querySelectorAll('input[name="adults"]').forEach((r) => r.addEventListener("change", sync));
    sync();
  }
  $("one-time")?.addEventListener("change", () => { const r = $("adult-one"); if (r && !r.checked) r.click(); });
  $("buy-more")?.addEventListener("click", () => setTimeout(paint, 0));
  form.addEventListener("submit", async (e) => {
    if (!on) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const err = $("purchase-error");
    const plan = adults() > 1 ? d.plan2 : d.plan;
    if (!plan) { err.textContent = d.notConnected; err.hidden = false; err.focus({ preventScroll: true }); return; }
    const ctas = [form.querySelector(".cta"), $("sticky-cta")].filter(Boolean), labs = [$("cta-label"), $("sticky-cta-label")].filter(Boolean);
    const prev = labs.map((l) => l.textContent), addingTxt = api.config?.strings?.adding || "Adding…";
    if (ctas.some((c) => c.classList.contains("is-adding"))) return;
    ctas.forEach((c) => { c.classList.add("is-adding"); c.disabled = true; c.setAttribute("aria-busy", "true"); });
    labs.forEach((l) => (l.textContent = addingTxt));
    const done = () => { ctas.forEach((c) => { c.classList.remove("is-adding"); c.disabled = false; c.removeAttribute("aria-busy"); }); labs.forEach((l, i) => (l.textContent = prev[i])); };
    try {
      await api.add({ id: d.variant, quantity: 3 * adults(), selling_plan: plan });
      setTimeout(done, 400);
      document.querySelector("masi-cart-drawer")?.controller
        ? document.dispatchEvent(new CustomEvent("masi:cart:open", { detail: { trigger: e.submitter } }))
        : location.assign(api.config.root.replace(/\/$/, "") + "/cart");
    } catch (x) { done(); err.textContent = x.message || t.error; err.hidden = false; }
  }, true);
  const savingsFormat = new Intl.NumberFormat(api.config.locale, {
    style: "currency", currency: api.config.currency, currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0
  });
  const currencyScale = 10 ** savingsFormat.resolvedOptions().maximumFractionDigits;
  const usdRate = Number(window.Currency?.rates?.USD), localRate = Number(window.Currency?.rates?.[api.config.currency]);
  const shippingSavings = api.config.currency === "USD" ? 7000
    : usdRate > 0 && localRate > 0 ? Math.round(Math.round(70 * usdRate / localRate * currencyScale) / currencyScale * 100) : null;
  const savingsText = (template, cents) => template.replace("[amount]", savingsFormat.format(cents / 100));
  function updateSavings() {
    if (!d.t.ship || !d.t.total || !$("m3-total-row")) return;
    const gifts = api.config.gifts.filter(g => g.available).reduce((total, g) => total + Math.max(0, Number(g.price) || 0), 0);
    if (shippingSavings !== null) {
      const shipping = savingsText(d.t.ship, shippingSavings);
      if ($("m3-ship-line").textContent !== shipping) $("m3-ship-line").textContent = shipping;
      const total = savingsText(d.t.total, Math.max(0, d.list - d.unit) * 3 + shippingSavings + gifts);
      if ($("m3-total-line").textContent !== total) $("m3-total-line").textContent = total;
      $("m3-total-row").hidden = false;
    }
    const monthly = $("selection-checklist");
    if (!monthly || !d.sub1) return;
    let row = $("m30-total-row");
    if (!row) {
      row = document.createElement("li");
      row.id = "m30-total-row";
      const check = document.createElement("span"), copy = document.createElement("span");
      check.className = "check-symbol"; check.setAttribute("aria-hidden", "true"); check.textContent = "✓";
      copy.id = "m30-total-line";
      row.append(check, copy); monthly.append(row);
    }
    const total = savingsText(d.t.total, Math.max(0, d.list - d.sub1) + gifts);
    if ($("m30-total-line").textContent !== total) $("m30-total-line").textContent = total;
  }
  updateSavings();
  if ($("selection-checklist")) new MutationObserver(updateSavings).observe($("selection-checklist"), { childList: true });
  const subFix = () => {
    const a = adults(), day = $("sub-day"), pa = $("sub-per-adult");
    if (!day || !d.sub1) return;
    const want = a > 1 && d.sub2 ? money(d.sub2 * 2 / 30 / 2) : money(d.sub1 / 30), lab = a > 1 ? d.t.aday : d.t.day;
    if (day.textContent !== want) day.textContent = want;
    if (day.nextElementSibling.textContent !== lab) day.nextElementSibling.textContent = lab;
    if (pa && !pa.hidden) { pa.hidden = true; pa.style.display = "none"; }
    const sd = $("sticky-day");
    if (sd && !on && $("subscribe")?.checked && sd.textContent !== want + lab) sd.textContent = want + lab;
  };
  new MutationObserver(subFix).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["hidden"] });
  $("sticky-purchase") && new MutationObserver(subFix).observe($("sticky-purchase"), { subtree: true, childList: true, characterData: true });

  // v20: IM8-style price block on the plan cards (per-jar price, billing line + per-day).
  const PM_L = { en: ["/mo", "Billed [amount] every [n] weeks", "Billed once · no subscription"], de: ["/Monat", "[amount] alle [n] Wochen", "Einmalige Zahlung · kein Abonnement"], es: ["/mes", "Se factura [amount] cada [n] semanas", "Pago único · sin suscripción"], fr: ["/mois", "Facturé [amount] toutes les [n] semaines", "Paiement unique · sans abonnement"], it: ["/mese", "Addebito di [amount] ogni [n] settimane", "Pagamento unico · nessun abbonamento"], nl: ["/mnd", "[amount] gefactureerd elke [n] weken", "Eenmalige betaling · geen abonnement"], pt: ["/mês", "Cobrado [amount] a cada [n] semanas", "Pagamento único · sem subscrição"], pl: ["/mies.", "Płatność [amount] co [n] tygodni", "Płatność jednorazowa · bez subskrypcji"], lt: ["/mėn.", "Mokama [amount] kas [n] sav.", "Vienkartinis mokėjimas · be prenumeratos"] };
  const pmL = window.MASI_PM_L || PM_L[(document.documentElement.lang || "en").slice(0, 2).toLowerCase()] || PM_L.en;
  const pmBlock = (el) => {
    let b = el.querySelector(".masi-pm");
    if (!b) {
      b = document.createElement("span"); b.className = "masi-pm";
      b.innerHTML = '<span class="pm-top"><strong class="pm-price"></strong><span class="pm-mo"></span><s class="pm-list"></s></span><span class="pm-row"><span class="pm-billed"></span><span class="pm-day"></span></span>';
      el.querySelector(".plan-identity")?.appendChild(b); el.classList.add("has-pm");
    }
    return b;
  };
  const setT = (n, s) => { if (n && n.textContent !== s) n.textContent = s; };
  const pmPaint = () => {
    const a = adults(), rows = [];
    if (d.list && $("one-time-card")) rows.push([$("one-time-card"), d.list, d.list, 0]);
    if (d.sub1 && $("subscribe-card")) { const u = a > 1 && d.sub2 ? d.sub2 : d.sub1; rows.push([$("subscribe-card"), u, u * a, 4]); }
    if (d.unit) { const u = a > 1 && d.unit2 ? d.unit2 : d.unit; rows.push([card, u, u * 3 * a, 12]); }
    rows.forEach(([el, u, billed, wk]) => {
      const b = pmBlock(el);
      setT(b.querySelector(".pm-price"), money(u)); const mo = b.querySelector(".pm-mo"); setT(mo, wk ? pmL[0] : ""); mo.hidden = !wk;
      const ls = b.querySelector(".pm-list"); setT(ls, wk && d.list > u ? money(d.list) : ""); ls.hidden = !(wk && d.list > u);
      setT(b.querySelector(".pm-billed"), wk ? pmL[1].replace("[amount]", money(billed)).replace("[n]", wk) : pmL[2]);
      setT(b.querySelector(".pm-day"), money(u / 30) + (a > 1 ? d.t.aday : d.t.day));
    });
  };
  pmPaint();
  new MutationObserver(pmPaint).observe(form, { subtree: true, attributes: true, attributeFilter: ["aria-pressed", "checked"] });
  form.addEventListener("change", () => setTimeout(pmPaint, 0));
  form.addEventListener("click", () => setTimeout(pmPaint, 0));
  const lum = (c) => { const m = c.match(/\d+(\.\d+)?/g); if (!m) return 1; const [r, g, b] = m.slice(0, 3).map((x) => { x = +x / 255; return x <= 0.04045 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4; }); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
  const ratio = (a, b) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
  const ctaColor = () => {
    const banner = card.querySelector(".offer-banner");
    if (!banner) return;
    const bg = getComputedStyle(banner).backgroundColor, L = lum(bg);
    const fg = ratio(L, 1) >= ratio(L, lum("rgb(17,17,17)")) ? "#ffffff" : "#111111";
    const root = document.documentElement.style;
    if (root.getPropertyValue("--masi-cta-bg") !== bg) root.setProperty("--masi-cta-bg", bg);
    if (root.getPropertyValue("--masi-cta-fg") !== fg) root.setProperty("--masi-cta-fg", fg);
  };
  form.addEventListener("change", () => setTimeout(ctaColor, 0));
  form.addEventListener("click", () => setTimeout(ctaColor, 0));
  window.masiCtaColor = ctaColor;
  const giftPreview = (box) => {
    const summary = box?.querySelector("summary"), gifts = api.config.gifts.filter(g => g.available);
    if (!summary || !gifts.length || !d.t.giftsTitle || !d.t.giftsMeta || box.classList.contains("gift-preview")) return box;
    const preview = document.createElement("div"), row = document.createElement("div");
    preview.className = box.className + " gift-preview";
    row.className = "gift-preview-row";
    const images = document.createElement("span");
    images.className = "gift-preview-images";
    gifts.forEach(gift => {
      const item = document.createElement("span"), img = document.createElement("img"), name = document.createElement("span"), price = document.createElement("s"), prices = document.createElement("span"), free = document.createElement("strong");
      item.className = "gift-preview-item";
      const imageUrl = new URL(gift.image, location.origin);
      imageUrl.searchParams.set("width", "480");
      img.src = imageUrl.href; img.alt = gift.title; img.width = 104; img.height = 108; img.loading = "lazy"; img.decoding = "async";
      name.className = "gift-preview-name";
      name.textContent = gift.title.replace(/^MASI Travel Jar$/i, "Travel jar").replace(/^The\s+/i, "").replace(/\s+of Longevity(?=\s+eBook$)/i, "");
      if (name.textContent.endsWith(" eBook")) {
        const format = document.createElement("span");
        format.className = "gift-preview-format";
        format.textContent = " eBook";
        name.textContent = name.textContent.slice(0, -6);
        name.append(format);
      }
      price.textContent = savingsFormat.format(gift.price / 100);
      prices.className = "gift-preview-prices"; free.className = "gift-preview-free";
      free.textContent = d.t.free || "FREE";
      prices.append(price, free);
      item.append(img, name, prices); images.append(item);
    });
    const copy = document.createElement("span"), value = document.createElement("span");
    copy.className = "gift-preview-copy"; value.className = "gift-preview-meta";
    value.textContent = d.t.giftsMeta.split(" · ")[0].replace("[amount]", savingsFormat.format(gifts.reduce((sum, gift) => sum + gift.price, 0) / 100));
    copy.append(value);
    row.append(images, copy);
    box.replaceWith(preview);
    box.className = "gift-preview-legacy"; box.hidden = true;
    preview.append(box, row);
    return preview;
  };
  const cloneGifts = () => {
    const src = $("subscribe-body")?.querySelector(".gift-kit"), body = $("m3-body");
    if (!src || !body) return;
    const preview = giftPreview(src);
    body.querySelector(".gift-kit")?.remove();
    const g = preview.cloneNode(true);
    g.open = false; g.classList.add("m3-gift-kit");
    g.querySelectorAll("[id]").forEach((n) => n.removeAttribute("id"));
    body.append(g);
  };
  setTimeout(cloneGifts, 0);
  let last = on ? "90" : "30";
  const subCard = $("subscribe-card");
  const setCompare = () => {
    const ot = $("one-time")?.checked && !on;
    subCard?.classList.toggle("compare-open", !!ot && last === "30");
    card.classList.toggle("compare-open", !!ot && last === "90");
    if (ot && last === "90") $("m3-body").hidden = false;
  };
  const pick = (which) => {
    if (which === "90") { if (!on) { radio.checked = true; on = true; paint(); } }
    else if (!$("subscribe")?.checked || on) $("subscribe")?.click();
  };
  radio.addEventListener("change", () => { last = "90"; setTimeout(setCompare, 0); });
  $("subscribe")?.addEventListener("change", () => { last = "30"; setTimeout(setCompare, 0); });
  $("one-time")?.addEventListener("change", () => setTimeout(setCompare, 0));
  [[subCard, "30"], [card, "90"]].forEach(([el, w]) => el?.addEventListener("click", (e) => {
    if (!el.classList.contains("compare-open") || e.target.closest("summary,details")) return;
    pick(w); setTimeout(setCompare, 0);
  }, true));
  subFix();
  paint();
  // Add-to-cart feedback for the native (30-day / one-time) path: spinner while the cart is busy after a submit.
  let submitted = false;
  form.addEventListener("submit", () => { if (!on) { submitted = true; [form.querySelector(".cta"), $("sticky-cta")].forEach((c) => c?.classList.add("is-adding")); } }, true);
  document.addEventListener("masi:cart:busy", (e) => { if (!e.detail && submitted) { submitted = false; setTimeout(() => [form.querySelector(".cta"), $("sticky-cta")].forEach((c) => c?.classList.remove("is-adding")), 300); } });
  // Selection "perfect" shimmer: only on user-driven selection changes, never on load.
  const fxReduce = matchMedia("(prefers-reduced-motion: reduce)");
  let fxReady = false; setTimeout(() => { fxReady = true; }, 600);
  // v22: base PDP script briefly re-selects the 30-day card when adults change; restore the 90-day selection
  // synchronously (MutationObserver microtask, before the browser paints) so nothing flashes.
  const sc = $("subscribe-card");
  sc && new MutationObserver(() => { if (on && sc.classList.contains("selected")) paint(); }).observe(sc, { attributes: true, attributeFilter: ["class"] });
  const otc = $("one-time-card");
  otc && new MutationObserver(() => { if (on && otc.classList.contains("selected")) paint(); }).observe(otc, { attributes: true, attributeFilter: ["class"] });
  const mainCta = form.querySelector(".cta"), purchaseError = $("purchase-error");
  const placeCta = () => {
    const selected = form.querySelector(".plan-card.selected");
    if (!selected || !mainCta) return;
    if (mainCta.parentElement !== selected) selected.append(mainCta);
    if (purchaseError && purchaseError.parentElement !== selected) selected.append(purchaseError);
  };
  const ctaPlacement = new MutationObserver(placeCta);
  [card, sc, otc].forEach(el => el && ctaPlacement.observe(el, { attributes: true, attributeFilter: ["class"] }));
  placeCta();
  ["cta-label", "sticky-cta-label"].forEach((id) => { const n = $(id); n && new MutationObserver(fixLabel).observe(n, { childList: true, characterData: true, subtree: true }); });
  // Sweep only when a card is newly selected and the selection is still in place at the next frame.
  [sc, $("one-time-card"), card].forEach((el) => {
    if (!el) return;
    let shown = el.classList.contains("selected"), raf = 0;
    new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const now = el.classList.contains("selected");
        if (now && !shown && fxReady && !fxReduce.matches) {
          el.classList.remove("masi-fx"); void el.offsetWidth; el.classList.add("masi-fx");
          clearTimeout(el._fxT); el._fxT = setTimeout(() => el.classList.remove("masi-fx"), 2700);
        }
        if (!now && el.classList.contains("masi-fx")) { clearTimeout(el._fxT); el.classList.remove("masi-fx"); }
        shown = now;
      });
    }).observe(el, { attributes: true, attributeFilter: ["class"] });
  });
  // FIX 29 Oct 2026: the sticky bar mirrors the selected plan card's price block
  // (big per-month price + struck list price, billing line below), same text/logic as the buy box.
  const sp = $("sticky-purchase");
  const stickyMirror = () => {
    const box = sp && sp.querySelector(".sticky-price");
    if (!box) return;
    const pm = form.querySelector(".plan-card.selected .masi-pm");
    if (!pm) { if (sp.classList.contains("has-pm-mirror")) sp.classList.remove("has-pm-mirror"); return; }
    let m = box.querySelector(".sticky-pm");
    if (!m) {
      m = document.createElement("span"); m.className = "sticky-pm";
      m.innerHTML = '<span class="sticky-pm-top"><strong class="sticky-pm-price"></strong><span class="sticky-pm-mo"></span><s class="sticky-pm-list"></s></span><small class="sticky-pm-billed"></small>';
      box.appendChild(m);
    }
    const src = (c) => pm.querySelector(c), show = (n) => Boolean(n && !n.hidden && n.textContent.trim());
    const sync = (from, to) => { const v = show(from); setT(to, v ? from.textContent : ""); if (to.hidden === v) to.hidden = !v; };
    setT(m.querySelector(".sticky-pm-price"), src(".pm-price")?.textContent || "");
    sync(src(".pm-mo"), m.querySelector(".sticky-pm-mo"));
    sync(src(".pm-list"), m.querySelector(".sticky-pm-list"));
    sync(src(".pm-billed"), m.querySelector(".sticky-pm-billed"));
    if (!sp.classList.contains("has-pm-mirror")) sp.classList.add("has-pm-mirror");
  };
  if (sp) {
    stickyMirror();
    const mirrorObs = new MutationObserver(stickyMirror);
    mirrorObs.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["class", "hidden"] });
    form.addEventListener("change", () => setTimeout(stickyMirror, 0));
    form.addEventListener("click", () => setTimeout(stickyMirror, 0));
  }
  ctaColor();
})();
